import { styled } from '@mui/material';

import palette from '../theme/palette';

interface ToggleProps {
  active: boolean;
  onChange: (value: boolean, e?: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
}

const Container = styled('div')({
  display: 'flex',
  borderRadius: 8,
  border: `1px solid ${palette.grey[1200]}`,
  background: palette.white,
  padding: 4,
  width: 'fit-content',
  gap: 0
});

const Tab = styled('button')<{
  active?: boolean;
}>(({ active }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '90px',
  padding: '8px 0',
  border: 'none',
  outline: 'none',
  borderRadius: 6,
  background: active ? palette.white : 'transparent',
  color: active ? palette.black : palette.grey[400],
  fontFamily: 'Reddit Sans',
  fontWeight: 500,
  fontSize: 11,
  lineHeight: '14px',
  cursor: 'pointer',
  transition:
    'background 0.3s cubic-bezier(0.4,0,0.2,1), color 0.3s cubic-bezier(0.4,0,0.2,1), box-shadow 0.3s cubic-bezier(0.4,0,0.2,1)',
  boxShadow: active ? `0 0 0 1px ${palette.purple[200]}` : 'none'
}));

const Dot = styled('div')({
  width: 5,
  height: 5,
  background: palette.purple[300],
  borderRadius: '50%',
  marginRight: 6
});

const ToggleActive = ({ active, onChange, className }: ToggleProps) => (
  <Container className={className}>
    <Tab
      type="button"
      active={active}
      onClick={e => !active && onChange(true, e)}
      aria-pressed={active}
    >
      {active && <Dot />}
      Active
    </Tab>
    <Tab
      type="button"
      active={!active}
      onClick={e => active && onChange(false, e)}
      aria-pressed={!active}
    >
      Not Active
    </Tab>
  </Container>
);

export default ToggleActive;
